(function () {
  // 1) Links that open in a new tab: notice + safe rel
  document.querySelectorAll('a[target="_blank"]').forEach(a => {
    if (!a.querySelector('.sr-only')) {
      const sr = document.createElement('span');
      sr.className = 'sr-only';
      sr.textContent = ' (opens in a new tab)';
      a.appendChild(sr);
    }
    if (!a.rel || !a.rel.match(/noopener|noreferrer/)) {
      a.rel = (a.rel ? a.rel + ' ' : '') + 'noopener noreferrer';
    }
  });

  // 4) Accessible menu (dropdowns): aria-haspopup/expanded
  document.querySelectorAll('[data-has-dropdown], .has-dropdown').forEach(trigger => {
    trigger.setAttribute('aria-haspopup', 'true');
    if (!trigger.hasAttribute('aria-expanded')) trigger.setAttribute('aria-expanded', 'false');
    trigger.addEventListener('click', () => {
      const expanded = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', String(!expanded));
    });
  });

  // 5) Modals/overlays: role="dialog" + aria-modal + focus
  document.querySelectorAll('.modal, .popup, [data-modal]').forEach(modal => {
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    const title = modal.querySelector('[data-modal-title], h2, h1');
    if (title && !modal.hasAttribute('aria-labelledby')) {
      const id = title.id || (title.id = 'dlg-title-' + Math.random().toString(36).slice(2));
      modal.setAttribute('aria-labelledby', id);
    }
  });

  // Basic focus trap for active modals
  function trapFocus(container) {
    const focusables = container.querySelectorAll('a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])');
    if (!focusables.length) return;
    const first = focusables[0], last = focusables[focusables.length - 1];
    container.addEventListener('keydown', (e) => {
      if (e.key !== 'Tab') return;
      if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
      else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
    });
  }

  // If you use .is-open class when modal opens:
  const observer = new MutationObserver(muts => {
    muts.forEach(m => {
      if (m.type === 'attributes' && m.attributeName === 'class' && m.target.classList.contains('is-open')) {
        trapFocus(m.target);
        const firstFocusable = m.target.querySelector('a, button, [tabindex]:not([tabindex="-1"])');
        if (firstFocusable) firstFocusable.focus();
      }
    });
  });
  document.querySelectorAll('.modal, .popup, [data-modal]').forEach(el => observer.observe(el, { attributes: true }));

  // 6) Elements that “look like buttons” but aren’t
  document.querySelectorAll('span[role="button"], div[role="button"]').forEach(el => {
    if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '0');
    el.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); el.click(); }
    });
  });

  // 7) aria-hidden and tabindex for off-canvas (if applicable)
  document.querySelectorAll('[data-offcanvas]').forEach(panel => {
    const setHidden = (hidden) => {
      panel.setAttribute('aria-hidden', hidden ? 'true' : 'false');
      panel.setAttribute('tabindex', hidden ? '-1' : '0');
    };
    // Example: if your script toggles .is-open
    const mo = new MutationObserver(() => setHidden(!panel.classList.contains('is-open')));
    mo.observe(panel, { attributes: true, attributeFilter: ['class'] });
    setHidden(!panel.classList.contains('is-open'));
  });

  document.querySelectorAll('a[target="_blank"]').forEach(a => {
    const label = a.getAttribute('aria-label') || a.textContent?.trim() || 'Link';
    if (!a.getAttribute('aria-label')?.includes('opens in a new tab')) {
      a.setAttribute('aria-label', `${label} (opens in a new tab)`);
    }
  });

  // 9.3 — Figures used only for layout → role="none"
  document.querySelectorAll('figure._bg, figure:has(img[role="presentation"])').forEach(fig => {
    fig.setAttribute('role', 'none');
  });

})();

(function () {
  /**
   * Function to enable accessibility on elements that act as buttons
   * @param {Element} el - Element to improve
   */
  function makeAccessibleButton(el) {
    if (!el.hasAttribute('role')) {
      el.setAttribute('role', 'button');
    }
    if (!el.hasAttribute('tabindex')) {
      el.setAttribute('tabindex', '0');
    }

    // Keyboard support
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        el.click();
      }
    });
  }

  // Selectors: add here the classes used for “fake buttons”
  const selectors = [
    'span._filter',
    'div._filter',
    'a._filter',
    'span.clickable',
    'div.clickable',
    'a.clickable',
    'span[data-filter]',
    'div[data-filter]',
    'a[data-filter]'
  ];

  document.querySelectorAll(selectors.join(',')).forEach(el => {
    if (el.tagName.toLowerCase() !== 'button') {
      makeAccessibleButton(el);
    }
  });
})();

// Add sr-only label if missing, and aria-required if field is required
document.querySelectorAll('input, textarea, select').forEach(el => {
  const id = el.id || ('fld-' + Math.random().toString(36).slice(2));
  if (!el.id) el.id = id;

  const hasLabel = !!document.querySelector(`label[for="${id}"]`);
  if (!hasLabel) {
    const label = document.createElement('label');
    label.className = 'sr-only';
    label.setAttribute('for', id);
    const name = el.getAttribute('name') || el.placeholder || 'Field';
    label.textContent = name.toString().replace(/[_\[\]]+/g, ' ').trim();
    el.parentNode?.insertBefore(label, el);
  }

  if (el.hasAttribute('required')) el.setAttribute('aria-required', 'true');
  // Basic validity state
  el.addEventListener('input', () => {
    el.setAttribute('aria-invalid', String(!el.checkValidity()));
  });
});

document.querySelectorAll('form').forEach(f => {
  const isSearch = f.getAttribute('role') === 'search' || f.querySelector('input[type="search"], input[name="q"]');
  if (isSearch) f.setAttribute('role', 'search');
});

document.querySelectorAll('.splide').forEach((el, i) => {
  el.setAttribute('role', 'region');
  el.setAttribute('aria-label', el.getAttribute('aria-label') || `Carousel ${i+1}`);
  const track = el.querySelector('.splide__track');
  if (track) track.setAttribute('aria-roledescription', 'carousel');
  // pagination “dots”
  el.querySelectorAll('.splide__pagination__page').forEach((dot, idx) => {
    dot.setAttribute('aria-label', `Go to slide ${idx+1}`);
  });
});
